import { z } from 'zod';
export const STARTER_FAMILIES = ['sdxl', 'sdxl-lightning', 'pony', 'sd15', 'flux', 'sd35', 'z-image', 'seedance', 'minimax-h3'];
export const StarterFamilySchema = z.enum(STARTER_FAMILIES);
/** The model files a family is built from (docs 29, 32). */
export const STARTER_SLOTS = ['checkpoint', 'lora', 'diffusion', 'textEncoder', 'vae'];
export const StarterSlotSchema = z.enum(STARTER_SLOTS);
export const StarterSchema = z.object({
    family: StarterFamilySchema,
    title: z.string(),
    description: z.string(),
    kind: z.enum(['image', 'video']),
    /** Runs in the cloud on the user's Comfy.org credits. */
    paid: z.boolean(),
    ready: z.boolean(),
    /** Per slot the installed files that fit, best first. */
    files: z.array(z.object({ slot: StarterSlotSchema, label: z.string(), choices: z.array(z.string()) })),
    /** What is still needed: a starter model (catalogId) for the machine page, or something in Account. */
    missing: z.array(z.object({ title: z.string(), catalogId: z.string().nullable(), where: z.enum(['machine', 'account']) })),
});
export const StartersResponseSchema = z.object({ starters: z.array(StarterSchema) });
export const FromStarterRequestSchema = z.object({
    machineId: z.string().min(1).max(64),
    family: StarterFamilySchema,
    prompt: z.string().trim().min(1, 'Required').max(2000),
    /** A choice per slot; the first installed file otherwise. */
    files: z.partialRecord(StarterSlotSchema, z.string().min(1).max(255)).optional(),
    title: z.string().trim().min(1).max(120).optional(),
});
//# sourceMappingURL=starters.js.map